import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_container_trailer_page_list = _resolveComponent("container-trailer-page-list")!

  return (_openBlock(), _createBlock(_component_container_trailer_page_list, {
    list: _ctx.list,
    addPower: "ContainerTrailer_DestinationPort_Add",
    editPower: "ContainerTrailer_DestinationPort_Edit",
    deletePower: "ContainerTrailer_DestinationPort_Delete",
    serviceType: _ctx.serviceType,
    poolId: _ctx.$route.params.id,
    disabledHistories: true
  }, null, 8, ["list", "serviceType", "poolId"]))
}